import React from 'react';

const TEMPLATES = [
  'atrium_consent_en',
  'atrium_consent_es',
  'baystate_consent_en',
  'baystate_consent_es',
  'montrealortho_consent_hip_en',
  'montrealortho_consent_hip_fr',
  'montrealortho_consent_knee_en',
  'montrealortho_consent_knee_fr',
  'mountsinai_consent',
  'nshealth_consent',
  'oakvalley_consent_en',
  'oakvalley_consent_zh-cn',
  'ohio_bariatrics_consent',
  'ohio_foregut_consent',
  'ohio_hernia_consent',
  'sjhh_consent',
];

export function ConsentDoc({ template }) {
  const html = `/html/${template}.html`;

  function iframe() {
    return {
      __html: `<iframe title="Consent form" src=${html} width="100%" height="450"></iframe>`,
    };
  }

  if (!TEMPLATES.includes(template)) {
    return null;
  }

  return (
    <div className="w-full border-3 mb-4" dangerouslySetInnerHTML={iframe()} />
  );
}
